/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useState } from "react";
import { Container } from 'reactstrap';
import { appRoles } from "../authConfig";
import NavMenu from './NavMenu';
import SideNavMenu from "./SideNavMenu";
import "../styles/Layout.css";



const PageLayout: React.FunctionComponent<any> = props => {
    const [appClassName, setAppClassName] = useState('App');
    const updateSidebar = (isOpen: boolean) => {
        if (isOpen) {
            setAppClassName('App');
        } else {
            setAppClassName('App-closed');
        }
    }
    return (
        <React.Fragment>
            <NavMenu callback={updateSidebar} />
            <Container id="Nova-container">
                <div className={appClassName}>
                    {/*<SideNavMenu />*/}
                    {props.children}
                </div>
            </Container>
        </React.Fragment>
    );
};

export default PageLayout;
    
